// ---- extend Number object with methods for converting degrees/radians

/** Converts numeric degrees to radians */
if (typeof(Number.prototype.toRad) === "undefined") {
    Number.prototype.toRad = function() {
      return this * Math.PI / 180;
    }
  }
  
  /** Converts radians to numeric (signed) degrees */
  if (typeof(Number.prototype.toDeg) === "undefined") {
    Number.prototype.toDeg = function() {
      return this * 180 / Math.PI;
    }
  }
  
  /**
   * Formats the significant digits of a number, using only fixed-point notation (no exponential)
   *
   * @param   {Number} precision: Number of significant digits to appear in the returned string
   * @returns {String} A string representation of number which contains precision significant digits
   */
  if (typeof(Number.prototype.toPrecisionFixed) === "undefined") {
    Number.prototype.toPrecisionFixed = function(precision) {
      if (isNaN(this)) return 'NaN';
      var numb = this < 0 ? -this : this;  // can't take log of -ve number...
      var sign = this < 0 ? '-' : '';
  
      if (numb == 0) { n = '0.'; while (precision--) n += '0'; return n };  // can't take log of zero
  
      var scale = Math.ceil(Math.log(numb)*Math.LOG10E);  // no of digits before decimal
      var n = String(Math.round(numb * Math.pow(10, precision-scale)));
      if (scale > 0) {  // add trailing zeros & insert decimal as required
        l = scale - n.length;
        while (l-- > 0) n = n + '0';
        if (scale < n.length) n = n.slice(0,scale) + '.' + n.slice(scale);
      } else {          // prefix decimal and leading zeros if required
        while (scale++ < 0) n = '0' + n;
        n = '0.' + n;
      }
      return sign + n;
    }
  }
  
  /** Trims whitespace from string (q.v. blog.stevenlevithan.com/archives/faster-trim-javascript) */
  if (typeof(String.prototype.trim) === "undefined") {
    String.prototype.trim = function() {
      return String(this).replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
  }
  
  if(Garmin == undefined) var Garmin = {};
  if(Garmin.Map == undefined) {
      Garmin.Map = {};
  }
  
  Garmin.Map.Utils = {
  
      MEASURE_STATUTE: 'statute',
      RADIUS_KILOMETERS: 6371,
      RADIUS_MILES: 3959,
      FEET_PER_METER: 3.28083989501312,
      MARKER: "marker-",
      POLYLINE: "polyline-",
      LAP_MARKER_URL: "/modern/images/feature/courses/lap-marker-",
      SHADOW_URL: "/api/activity-search/style/explore/images/pin-shadow.png",
      METRIC: "metric",
      GEO_OFFSET: 0.00007, // Used to keep markers from overlapping on return to start function.
      GEO_BUFFER: 0.00007, // Used to test if the end marker is already near the start marker
      BUSY_DIV_ID: 'loading-mask',
      MAP_STYLE_ROAD: 'road',
      MAP_STYLE_SATELLITE: 'satellite',
      MAP_STYLE_HYBRID: 'hybrid',
      MAP_STYLE_AUTO: 'auto',
      MAP_STYLE_TERRAIN: 'terrain',
      MAP_STYLE_BICYCLE: 'bicycle',
      MAP_STYLE_OSM: 'osm',
      PROVIDER_TYPE_HERE: 'here',
      PROVIDER_TYPE_GOOGLE: 'google',
      PROVIDER_TYPE_OSM: 'osm',
      PROVIDER_TYPE_NUMAP: 'numap',
      PROVIDER_TYPE_BAIDU: 'BAIDU_V_1_4',
      PROVIDER_TYPE_MOCK: 'mock',
      MAXIMUM_ELEVATION_SAMPLES: 512,
      MAXIMUM_ELEVATION_PATH_POINTS: 375,
  
      LINE_COLOR: [255, 0, 0],
  
      LINE_OPACITY: 0.8,
  
      LINE_WIDTH: 4,
  
      /**
       * Occurs when the location of the pushpin or polyline or any of the pushpin’s, polyline's options change.
       */
      EVENT_MARKER_CHANGED: "changed",
  
      /**
       *  Occurs when the mouse is used to click the pushpin, polyline, or map.
       */
      EVENT_MOUSE_CLICK: "click",
  
      /**
       * Occurs when the mouse is used to double click the pushpin, polyline, or map.
       */
      EVENT_MOUSE_DBLCLICK: "doubleclick",
  
      /**
       *  Occurs when the left mouse button is pressed when the mouse is over the pushpin, polyline, or map.
       */
      EVENT_MOUSE_DOWN: "mousedown",
  
      /**
       * Occurs when the mouse cursor moves out of the area covered by the pushpin, polyline, or map.
       */
      EVENT_MOUSE_OUT: "mouseout",
  
      /**
       * Occurs when the mouse is over the pushpin, polyline, or map.
       */
      EVENT_MOUSE_OVER: "mouseover",
  
      /**
       * Occurs when the left mouse button is lifted up when the mouse is over the pushpin, polyline, or map.
       */
      EVENT_MOUSE_UP: "mouseup",
  
      /**
       * Occurs when the mouse scroll wheel is rotated and the cursor is over a map
       */
      EVENT_MOUSE_WHEEL: "mousewheel",
  
      /**
       * Occurs when the right mouse button is used to click the pushpin, polyline, or map.
       */
      EVENT_MOUSE_RIGHT_CLICK: "rightclick",
  
      /**
       * Occurs when the map view starts changing.
       */
      EVENT_MAP_VIEW_CHANGE_START: "viewchangestart",
  
      /**
       * Occurs when the map view is done changing.
       */
      EVENT_MAP_VIEW_CHANGE_END: "viewchangeend",
  
      EVENT_MAP_ZOOM_CHANGED: "zoomchanged",
  
      EVENT_MAP_IDLE: "idle",
  
      EVENT_DRAG_START: "dragstart",
  
      EVENT_DRAG_END: "dragend",
  
      EVENT_DRAGGING: "dragging",
  
      EVENT_TARGET_MAP: "map",
  
      EVENT_TARGET_MARKER: "marker",
  
      EVENT_TARGET_POLYLINE: "polyline",
  
      EVENT_TOGGLE_HEATMAP_ITEMS: "toggleHeatmapItems",
  
      EVENT_OSM_MAP_READY: "osmMapReady",
  
      /**
       * The layer upon which polylines are drawn.
       */
      LAYER_POLYLINES: "polylineLayer",
  
      /**
       * The entity index of the layer upon which start and end markers are placed.
       */
      LAYER_TERMINUS: "terminusLayer",
  
      /**
       * The layer upon which markers OTHER than distance, start and end markers are placed.
       */
      LAYER_MARKERS: "markerLayer",
  
      /**
       * The layer upon which segment polylines are drawn.
       */
      LAYER_SEGMENTS: "segmentsLayer",
  
      /**
       * The layer upon which the segment polyline is drawn.
       */
      LAYER_SEGMENT: "segmentLayer",
  
      /**
       * The layer upon which distance markers are placed.
       */
      LAYER_DISTANCE_CLOSE: "distanceLayerClose",
      LAYER_DISTANCE_MEDIUM: "distanceLayerMedium",
      LAYER_DISTANCE_FAR: "distanceLayerFar",
      LAYER_DISTANCE_MAX: "distanceLayerMax",
  
      heatmapPreferences: null,
      heatmapFolderDataList: null,
      heatmapRenderedTileDataList: new Object(),
      activityType: "",
  
      /**
       * Given a set of points, return an array of two Garmin.Map.Point
       * representing the minimum and maximum lat/long values.
       *
       * @param points - An array of Garmin.Map.Points
       * @return - Set of three Garmin.Map.Points.
       * minimum = min lat/lon Garmin.Map.Point,
       * maximum = max lat/lon Garmin.Map.Point
       * center = avg lat/lon  Garmin.Map.Poin (for center)
       */
      findMinMaxPoints: function(points) {
          if (typeof(points) != 'undefined' && points != null && points.length > 0) {
              var sumLat = 0;
              var sumLon = 0;
              var minLat = null;
              var minLon = null;
              var maxLat = null;
              var maxLon = null;
              var point = null;
              for (var i = 0; i < points.length; i++) {
                  point = points[i];
                  sumLat += point.lat;
                  sumLon += point.lon;
                  if (maxLat ==  null || point.lat > maxLat) {
                      maxLat = point.lat;
                  }
                  if (minLat == null || point.lat < minLat) {
                      minLat = point.lat;
                  }
                  if (maxLon ==  null || point.lon > maxLon) {
                      maxLon = point.lon;
                  }
                  if (minLon == null || point.lon < minLon) {
                      minLon = point.lon;
                  }
              }
              var results = {
                  minimum:  new Garmin.Map.Point(minLat,minLon),
                  maximum:  new Garmin.Map.Point(maxLat, maxLon),
                  center: new Garmin.Map.Point(sumLat/points.length, sumLon/points.length)
              }
          }
          return results;
      },
  
      calculateDistanceOfPoints: function(points, isMetric) {
          var distance = 0;
          if (typeof(points) != 'undefined') {
              var start;
              var end;
              var limit = points.length - 1;
              for (var i = 0; i < limit; i++) {
                  start = points[i];
                  end = points[i+1];
                  distance += this.calculateDistanceBetweenPoints(start, end, isMetric);
              }
          }
          return distance;
      },
  
      /**
       * From http://www.movable-type.co.uk/scripts/latlong.html.
       *  Returns the distance from this point to the supplied point, in km
       * (using Haversine formula)
       *
       * from: Haversine formula - R. W. Sinnott, "Virtues of the Haversine",
       *       Sky and Telescope, vol 68, no 2, 1984
       * @param point1 - Starting Garmin.Map.Point.
       * @param point2 - Ending Garmin.Map.Point.
       * @param  isMetric - True for kilometers, otherwise, miles
       * @return Distance between points.
       */
      calculateDistanceBetweenPoints: function(point1, point2, isMetric) {
        if (typeof(point1) == 'undefined') {
              throw "point 1 is required";
          }
          if (typeof(point2) == 'undefined') {
              throw "point 2 is required";
          }
          var radius = Garmin.Map.Utils.RADIUS_MILES
          if (isMetric) {
              radius =  Garmin.Map.Utils.RADIUS_KILOMETERS;
          }
          var dLat = (point2.lat - point1.lat).toRad();
          var dLon = (point2.lon - point1.lon).toRad();
  
          var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
              Math.cos(point1.lat.toRad()) * Math.cos(point2.lat.toRad()) *
              Math.sin(dLon/2) * Math.sin(dLon/2);
          var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
          return radius * c;
  //        var dx = Math.cos(point1.lat) * dLon;
  //        return  radius * Math.sqrt((dLat*dLat) + (dx*dx));
      },
  
      /**
       * Calculates the bearing of a line.
       * See http://www.movable-type.co.uk/scripts/latlong.html
       * @param start - starting Garmin.Map.Point.
       * @param end - Ending Garmin.Map.Point.
       * @param longitude2 - longitude of ending point.
       */
      calculateBearingOfPoints: function(start, end) {
              if (typeof(start) == 'undefined') {
                  throw "start is required";
              }
              if (typeof(end) == 'undefined') {
                  throw "end is required";
              }
              var lat1 = start.lat.toRad();
              var lat2 = end.lat.toRad();
              var dLon = (end.lon-start.lon).toRad();
              var y = Math.sin(dLon) * Math.cos(lat2);
              var x = Math.cos(lat1)*Math.sin(lat2) -
                    Math.sin(lat1)*Math.cos(lat2)*Math.cos(dLon);
              return Math.atan2(y, x).toDeg();
      },
  
      /**
       * Calculates a destination point a certain distance from a starting point
       * along a given bearing.
       * See http://www.movable-type.co.uk/scripts/latlong.html
       *  @param point - Starting Garmin.Map.Point in degrees.
       * @param dist - The distance to the destination
       * @param bearing - The bearing of the destination point from the starting point in degrees.
       * @param isMetric
       * @return Destination Garmin.Map.Point.
       */
      calculateDestinationPoint: function(point, dist, bearing, isMetric){
          if (typeof(point) == 'undefined') {
              throw "point 1 is required";
          }
          if (typeof(dist) == 'undefined') {
              throw "Distance is required";
          }
          if (typeof(bearing) == 'undefined') {
              throw "Bearing is required";
          }
          var radius = Garmin.Map.Utils.RADIUS_MILES; // miles
          if (isMetric) {
              radius = Garmin.Map.Utils.RADIUS_KILOMETERS; // km
          }
          var brng = bearing.toRad();
          var lat1 = point.lat.toRad();
          var lon1 = point.lon.toRad();
  
          var angularDistance = dist/radius;
          var lat2 = Math.asin( Math.sin(lat1)*Math.cos(angularDistance) +
                                Math.cos(lat1)*Math.sin(angularDistance)*Math.cos(brng) );
  
          var lon2 = lon1 + Math.atan2(Math.sin(brng)*Math.sin(angularDistance)*Math.cos(lat1),
                                       Math.cos(angularDistance)-Math.sin(lat1)*Math.sin(lat2));
  
          lon2 = (lon2+3*Math.PI)%(2*Math.PI) - Math.PI; // normalise to -180...+180
          return new Garmin.Map.Point(lat2.toDeg(), lon2.toDeg())
      },
  
      /**
       * The purpose of this method is to test whether a given point
       * falls exactly between two other points.
       * @param prevPoint - Garmin.Map.Point of first point.
       * @param middlePoint - Garmin.Map.Point of point to be tested.
       * @param nextPoint - Garmin.Map.Point of last point
       * @return - True if the middle point falls between the first and last points.
       */
      isExactlyBetweenPoints: function(prevPoint, middlePoint, nextPoint) {
          if (typeof(buffer) == 'undefined') {
              buffer = 0;
          }
          var isLatBetween = false;
          var isLonBetween = false;
          // Find any exact matches
          if (prevPoint.lat < nextPoint.lat) {
              isLatBetween = prevPoint.lat <= middlePoint.lat && middlePoint.lat <= nextPoint.lat;
          } else {
              isLatBetween =  prevPoint.lat >= middlePoint.lat && middlePoint.lat >= nextPoint.lat;
          }
          if (prevPoint.lon < nextPoint.lon) {
              isLonBetween = prevPoint.lon <= middlePoint.lon && middlePoint.lon <= nextPoint.lon;
          } else {
              isLonBetween =  prevPoint.lon >= middlePoint.lon && middlePoint.lon >= nextPoint.lon;
          }
          return isLatBetween && isLonBetween;
      },
  
          /**
       * The purpose of this method is to test whether a given point
       * falls roughly between two other points.
       * @param prevPoint - Garmin.Map.Point of first point.
       * @param middlePoint - Garmin.Map.Point of point to be tested.
       * @param nextPoint - Garmin.Map.Point of last point
       * @param buffer - (optional) A positive float tolerance for error
       * @return - True if the middle point falls between the first and last points.
       */
      isRoughlyBetweenPoints: function(prevPoint, middlePoint, nextPoint, buffer) {
          if (typeof(buffer) == 'undefined') {
              buffer = 0;
          }
          var isLatBetween = false;
          var isLonBetween = false;
          // Find any exact matches
          if (prevPoint.lat < nextPoint.lat) {
              isLatBetween = prevPoint.lat <= middlePoint.lat && middlePoint.lat <= nextPoint.lat;
          } else {
              isLatBetween =  prevPoint.lat >= middlePoint.lat && middlePoint.lat >= nextPoint.lat;
          }
          if (prevPoint.lon < nextPoint.lon) {
              isLonBetween = prevPoint.lon <= middlePoint.lon && middlePoint.lon <= nextPoint.lon;
          } else {
              isLonBetween =  prevPoint.lon >= middlePoint.lon && middlePoint.lon >= nextPoint.lon;
          }
          var latBuffer = buffer;
          var lonBuffer = buffer*2;
          // If not both true, using exact matches, continue using buffer.
          if (!(isLatBetween && isLonBetween)) {
              var diff1 = 0;
              var diff2 = 0;
              // See if other measure is within the allowable buffer NEAR either the two points. For example, clicking below a horizontal line
              // will be below (less than) the longitude of both points, not in between
              if (!isLonBetween) {
                  diff1 = Math.abs(prevPoint.lon - middlePoint.lon);
                  diff2 = Math.abs(nextPoint.lon - middlePoint.lon);
                  isLonBetween = diff1 < lonBuffer && diff2 < lonBuffer;
              } else if (!isLatBetween) {
                  diff1 = Math.abs(prevPoint.lat - middlePoint.lat);
                  diff2 = Math.abs(nextPoint.lat - middlePoint.lat);
                  isLatBetween = diff1 < latBuffer && diff2 < latBuffer;
              }
          }
          return isLatBetween && isLonBetween;
      },
  
          /**
       * This function is from Google's polyline utility.
       * @param encodedSamples - The encodedSamples attribute from GPolyline
       */
      decodeLine: function (encodedSamples) {
  
        var index = 0;
        var decodedSamples = [];
        var lat = 0;
        var lng = 0;
        if (encodedSamples && encodedSamples != undefined) {
            var len = encodedSamples.length;
            while (index < len) {
              var charVal;
              var offset = 0;
              var value = 0;
              do {
                charVal = encodedSamples.charCodeAt(index++) - 63;
                value |= (charVal & 0x1f) << offset;
                offset += 5;
              } while (charVal >= 0x20);
              var decodedLat = ((value & 1) ? ~(value >> 1) : (value >> 1));
              lat += decodedLat;
  
              offset = 0;
              value = 0;
              do {
                charVal = encodedSamples.charCodeAt(index++) - 63;
                value |= (charVal & 0x1f) << offset;
                offset += 5;
              } while (charVal >= 0x20);
              var decodedLng = ((value & 1) ? ~(value >> 1) : (value >> 1));
              lng += decodedLng;
  
              decodedSamples.push([lat * 1e-5, lng * 1e-5]);
            }
        }
        return decodedSamples;
      },
  
          /**
       * Calculates time as the quotient of distance/speed.
       * If either are zero then zero is returned.
       * @param distance - The distance traveled
       * @param speed - The speed in units per hour
       * @return distance/speed
       */
      calculateTime: function(distance, speed) {
         if (distance == 0 || speed == 0) {
             return 0;
         }
         return distance/speed;
      },
  
      /**
       * Calculates speed as the quotient of distance/time.
       * If either are zero then zero is returned.
       * @param distance - The distance traveled
       * @param time - The time to travel the given distance
       * @return distance/time
       */
      calculateSpeed: function(distance, time) {
         if (distance == 0 || time == 0) {
             return 0;
         }
         return distance/time;
      },
  
      formatTime: function(totalSeconds) {
  
         // Time is format to seconds, so round to the nearest second before formatting. This avoids
         // rounding errors when formatting time like 59.999999
         totalSeconds = Math.round(totalSeconds);
  
         var rval = new Array();
         var hours =  Math.floor(totalSeconds/3600);
         if (hours > 0)  {
             rval.push(hours);
             rval.push(":")
         }
         var minutes =  Math.floor((totalSeconds - (hours * 3600)) / 60);
         if (minutes < 10 && totalSeconds >= 3600) {
             rval.push(0);
         }
         rval.push(minutes);
         rval.push(":");
         var seconds =  Math.floor(totalSeconds - (hours * 3600) - (minutes * 60));
         if (seconds < 10) {
             rval.push(0);
         }
         if (seconds.length > 2) {
             seconds = seconds.substring(2);
         }
         rval.push(seconds);
         return rval.join("");
      },
  
      /**
       * Formats a float for display
       * @param value - The number to format
       * @param numberFormat (optional) 'decimal_comma', EU format, or 'decimal_period', default
       */
      formatFloat: function(value, numberFormat) {
        var rval = "";
        if (typeof(value) != 'undefined') {
          rval = value.toFixed(2);
          var lastDigit = rval.substr(rval.length - 1 );
          if (lastDigit == '0') {
              rval = rval.substr(0, rval.length - 1 );
              lastDigit = rval.substr(rval.length - 1 );
          }
        }
        if (typeof(numberFormat) == 'undefined' || numberFormat != 'decimal_comma') {
          return this.addNumberSeparators(rval, ',', '.');
        }
        return this.addNumberSeparators(rval, '.' , ',');
      },
  
      /**
       * Formats a float as a speed value. Speed is rounded to the nearest 10th.
       * @param value - The number to format
       * @param numberFormat (optional) 'decimal_comma', EU format, or 'decimal_period', default
       */
      formatSpeed: function(value, numberFormat) {
          var rval = "";
          if (typeof(value) != 'undefined') {
              rval = value.toFixed(1);
          }
  
          // Don't remove trailing zero if rounding to nearest 10th.
          if (typeof(numberFormat) == 'undefined' || numberFormat != 'decimal_comma') {
             return this.addNumberSeparators(rval, ',', '.');
           }
          return this.addNumberSeparators(rval, '.' , ',');
      },
  
      /**
       * Adds thousands separator and decimal place to number. Assumes that
       * input String does not have any thousands separator and is using a
       * period as the decimal place.
       *
       * http://www.mredkj.com/javascript/numberFormat.html
       * @param nStr
       * @param thousandsSeparator - Character used for thousands Separator
       * @param decimalPlace - Character used for decimal place
       */
      addNumberSeparators: function (nStr, thousandsSeparator, decimalPlace)
      {
          var x;
          nStr += '';
          x = nStr.split('.');
          var x1 = x[0];
          var x2 = x.length > 1 ? decimalPlace + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
              x1 = x1.replace(rgx, '$1' + thousandsSeparator + '$2');
          }
          return x1 + x2;
      },
  
      getCityFolderMatchesForBoundingBoxAndActivityType:function(northwest_point, southeast_point, activityType, performRenderedTileCheck, x, y, zoom) {
          var cityName = '';
          var cityNames = new Array();
          if (Garmin.Map.Utils.heatmapFolderDataList != null
              && Garmin.Map.Utils.heatmapFolderDataList.length > 0) {
              for(var i = 0; i < Garmin.Map.Utils.heatmapFolderDataList.length; i++) {
                  var heatmapData = Garmin.Map.Utils.heatmapFolderDataList[i];
                  var cityLatLngNW = new Garmin.Map.Point(heatmapData.boundBoxNWLatitude, heatmapData.boundBoxNWLongitude, 0);
                  var cityLatLngSE = new Garmin.Map.Point(heatmapData.boundBoxSELatitude, heatmapData.boundBoxSELongitude, 0);
                  if (cityNames.length < 3
                      && heatmapData.activityType == activityType
                      && Garmin.Map.Utils.doBoundingBoxesIntersect(northwest_point, southeast_point, cityLatLngNW, cityLatLngSE)) {
                      if (performRenderedTileCheck) {
                          if (Garmin.Map.Utils.doTileCoordindatesHaveRenderedTilesForFolderName(x, y, zoom, heatmapData.folderName, heatmapData.folderId)) {
                              cityName = heatmapData.folderName;
                              cityNames.push(cityName);
                          }
                      } else {
                          cityName = heatmapData.folderName;
                          cityNames.push(cityName);
                      }
                  }
              }
          }
  
          return cityNames;
      },
  
      getCityFolderMatchesForLocationAndActivityType:function(x, y, zoom, activityType, performRenderedTileCheck) {
          var nwLatLng = Garmin.Map.Utils.minPointToLatLng(x, y, zoom);
          var seLatLng = Garmin.Map.Utils.maxPointToLatLng(x, y, zoom);
          var northwest_point = new Garmin.Map.Point(nwLatLng.lat, nwLatLng.lon, 0);
          var southeast_point = new Garmin.Map.Point(seLatLng.lat, seLatLng.lon, 0);
          return Garmin.Map.Utils.getCityFolderMatchesForBoundingBoxAndActivityType(northwest_point, southeast_point, activityType, performRenderedTileCheck, x, y, zoom);
      },
  
      getGlobalFolderMatchesForLocationAndActivityType:function(x, y, zoom, activityType, performRenderedTileCheck) {
          var cityName = '';
          var cityNames = new Array();
          if (Garmin.Map.Utils.heatmapFolderDataList != null
              && Garmin.Map.Utils.heatmapFolderDataList.length > 0) {
              for(var i = 0; i < Garmin.Map.Utils.heatmapFolderDataList.length; i++) {
                  var heatmapData = Garmin.Map.Utils.heatmapFolderDataList[i];
                  if (cityNames.length < 3
                      && heatmapData.activityType == activityType
                      && heatmapData.boundBoxNWLatitude == 0) {
                      if (performRenderedTileCheck) {
                          if (Garmin.Map.Utils.doTileCoordindatesHaveRenderedTilesForFolderName(x, y, zoom, heatmapData.folderName, heatmapData.folderId)) {
                              cityName = heatmapData.folderName;
                              cityNames.push(cityName);
                          }
                      } else {
                          // override for quick local testing. Rendered tile check was put in place to avoid 403s as we only produce tiles that we have heat for
                          cityName = heatmapData.folderName;
                          cityNames.push(cityName);
                      }
                  }
              }
          }
  
          return cityNames;
      },
  
      doTileCoordindatesHaveRenderedTilesForFolderName:function(x, y, zoom, foldername, folderid) {
          var renderedTilesExistForFolderName = false;
          if (Garmin.Map.Utils.heatmapRenderedTileDataList[folderid] == null) {
              Garmin.Map.Utils.heatmapRenderedTileDataList[folderid] = Garmin.Map.Utils.getHeatMapRenderedTileDataForFolder(foldername);
          }
          if (Garmin.Map.Utils.heatmapRenderedTileDataList[folderid] != null
              && Garmin.Map.Utils.heatmapRenderedTileDataList[folderid].length > 0) {
              for(var i = 0; i < Garmin.Map.Utils.heatmapRenderedTileDataList[folderid].length; i++) {
                  var heatmapRenderedTileData = Garmin.Map.Utils.heatmapRenderedTileDataList[folderid][i];
                  if (heatmapRenderedTileData.tileZoomLevel == zoom
                      && heatmapRenderedTileData.tileXCoordinate == x
                      && heatmapRenderedTileData.tileYCoordinate == y) {
                      renderedTilesExistForFolderName = true;
                      return renderedTilesExistForFolderName;
                  }
              }
          }
  
          return renderedTilesExistForFolderName;
      },
  
      populateTileUrls: function (cityNames, tileBaseUrl, zoom, google_coord, tileUrls) {
          if (cityNames != null && cityNames.length > 0) {
              if (cityNames[2] != null) {
                  var tileUrl2 = tileBaseUrl + Garmin.Map.Utils.heatmapPreferences.heatmapActiveVersion + "/" + cityNames[2] +
                      "/" + zoom + "/tile_" + google_coord.x + "_" + google_coord.y + ".png";
                  tileUrls.push(tileUrl2);
              }
              if (cityNames[1] != null) {
                  var tileUrl1 = tileBaseUrl + Garmin.Map.Utils.heatmapPreferences.heatmapActiveVersion + "/" + cityNames[1] +
                      "/" + zoom + "/tile_" + google_coord.x + "_" + google_coord.y + ".png";
                  tileUrls.push(tileUrl1);
              }
              if (cityNames[0] != null) {
                  var tileUrl0 = tileBaseUrl + Garmin.Map.Utils.heatmapPreferences.heatmapActiveVersion + "/" + cityNames[0] +
                      "/" + zoom + "/tile_" + google_coord.x + "_" + google_coord.y + ".png";
                  tileUrls.push(tileUrl0);
              }
          }
      },
  
      getHeatMapPreferences: function() {
        /** do nothing */
      },

      getAllHeatMapFolderData: function(version) {
        return null;
      },

      getHeatMapRenderedTileDataForFolder: function(foldername) {
        return null;
      },
  
      log: function() {
          if (typeof console !== 'undefined' && typeof console.log !== 'undefined') {
  //            if (jQuery.browser.msie) {
  //                var str = "";
  //                for (var i = 0; i < arguments.length; i++) {
  //                    str += arguments[i] + ", ";
  //                }
  //                str = str.substring(0, str.length - 2); // remove the ", "
  //                console.log(str);
  //            } else { // real browser
                  console.log(arguments);
  //            }
          }
      },
  
      getHeatMapUrls: function(x, y, zoom) {
          var google_coord = Garmin.Map.Utils.getNormalizedCoord(x, y, zoom);
          if (!google_coord) {
              return null;
          }
  
          var tileUrls = new Array();
  
          var tileBaseUrl = Garmin.Map.Utils.heatmapPreferences.s3Url + Garmin.Map.Utils.heatmapPreferences.heatmapBaseBucketName + "/";
  
          if (zoom >= Garmin.Map.Utils.heatmapPreferences.heatmapCityZoomLevelStart) {
              var cityNames = Garmin.Map.Utils.getCityFolderMatchesForLocationAndActivityType(x, y, zoom, Garmin.Map.Utils.activityType, Garmin.Map.Utils.heatmapPreferences.performRenderedTileCheck);
              Garmin.Map.Utils.populateTileUrls(cityNames, tileBaseUrl, zoom, google_coord, tileUrls);
          } else if (zoom >= Garmin.Map.Utils.heatmapPreferences.heatmapGlobalZoomLevelStart) {
              var globalNames = Garmin.Map.Utils.getGlobalFolderMatchesForLocationAndActivityType(x, y, zoom, Garmin.Map.Utils.activityType, Garmin.Map.Utils.heatmapPreferences.performRenderedTileCheck);
              Garmin.Map.Utils.populateTileUrls(globalNames, tileBaseUrl, zoom, google_coord, tileUrls);
          }
          return tileUrls;
  
      },
  
      // Normalizes the coords that tiles repeat across the x axis (horizontally)
      // to ensure we have Google map tile coordinates
      getNormalizedCoord: function (x, y, zoom) {
          // tile range in one direction range is dependent on zoom level
          // 0 = 1 tile, 1 = 2 tiles, 2 = 4 tiles, 3 = 8 tiles, etc
          var tileRange = 1 << zoom;
  
          // don't repeat across y-axis (vertically)
          if (y < 0 || y >= tileRange) {
              return null;
          }
  
          // repeat across x-axis
          if (x < 0 || x >= tileRange) {
              x = (x % tileRange + tileRange) % tileRange;
          }
  
          return {
              x: x,
              y: y
          }
      },
  
      // Determines whether two bounding boxes intersect (Garmin.Map.Point model is used)
      doBoundingBoxesIntersect:function(bb1_northwest, bb1_southeast, bb2_northwest, bb2_southeast) {
  
          var rabx = Math.abs(bb1_northwest.lon + bb1_southeast.lon - bb2_northwest.lon - bb2_southeast.lon);
          var raby = Math.abs(bb1_northwest.lat + bb1_southeast.lat - bb2_northwest.lat - bb2_southeast.lat);
  
          var raxPrbx = bb1_southeast.lon - bb1_northwest.lon + bb2_southeast.lon - bb2_northwest.lon;
          var rayPrby = bb1_northwest.lat - bb1_southeast.lat + bb2_northwest.lat - bb2_southeast.lat;
  
          if(rabx <= raxPrbx && raby <= rayPrby)
          {
              return true;
          }
          return false;
      },
  
      // Returns min (northwest corner of the box) lat lon for a given Tile coordinate
      minPointToLatLng:function(x, y, zoom) {
  
          var minPixelX = x * 256;
          var minPixelY = y * 256;
          return Garmin.Map.Utils.fromPointToLatLng(minPixelX, minPixelY, zoom);
      },
  
      // Returns max (southeast corner of the box) lat lon for a given Tile coordinate
      maxPointToLatLng:function(x, y, zoom) {
  
          var maxPixelX = (x + 1) * 256 - 1;
          var maxPixelY = (y + 1) * 256 - 1;
          return Garmin.Map.Utils.fromPointToLatLng(maxPixelX, maxPixelY, zoom);
      },
  
      // Converts a pixel from pixel XY coordinates at a specified level of detail
      // into latitude/longitude WGS-84 coordinates (in degrees).
      // <param name="pixelX">X coordinate of the point, in pixels.</param>
      // <param name="pixelY">Y coordinates of the point, in pixels.</param>
      // <param name="levelOfDetail">Level of detail, from 1 (lowest detail)
      // to 23 (highest detail).</param>
      // <param name="latitude">Output parameter receiving the latitude in degrees.</param>
      // <param name="longitude">Output parameter receiving the longitude in degrees.</param>
      fromPointToLatLng:function(pixelX, pixelY, zoom) {
  
          var mapSize = Garmin.Map.Utils.mapSize(zoom);
          var calc_x = (Garmin.Map.Utils.clip(pixelX, 0, mapSize - 1) / mapSize) - 0.5;
          var calc_y = 0.5 - (Garmin.Map.Utils.clip(pixelY, 0, mapSize - 1) / mapSize);
          var latitude = (90 - 360 * Math.atan(Math.exp(-calc_y * 2 * Math.PI)) / Math.PI).toFixed(3);
          var longitude = (360 * calc_x).toFixed(3);
          return {
              lat: latitude,
              lon: longitude
          };
      },
  
      // Determines the map width and height (in pixels) at a specified level
      // of detail.
      // <param name="levelOfDetail">Level of detail, from 1 (lowest detail)
      // to 23 (highest detail).</param>
      // <returns>The map width and height in pixels.</returns>
      mapSize:function(levelOfDetail)
      {
          var mapSize = ((256 << levelOfDetail) >>> 0);
          return mapSize;
      },
  
      // Clips a number to the specified minimum and maximum values.
      // <param name="n">The number to clip.</param>
      // <param name="minValue">Minimum allowable value.</param>
      // <param name="maxValue">Maximum allowable value.</param>
      // <returns>The clipped value.</returns>
      clip:function (n, minValue, maxValue)
      {
          return Math.min(Math.max(n, minValue), maxValue);
      }
  
  
  }
  
  // Garmin.Map.Listener = function(name, action) {
  //     if (typeof name == 'undefined') {
  //         throw new Error("Name must not be null");
  //     }
  //      if (typeof action == 'undefined') {
  //         throw new Error("Action must not be null");
  //     }
  //     this.name = name;
  //     this.fire = action;
  // };
  
  // Garmin.Map.Event = {
  //     SWAP_MARKER_ID: 'swapmarkerid',
  //     ELEVATION_CHANGE: 'elevationChange',
  //     RESET_ROUTE: 'resetRoute'
  // };
  
  // Garmin.Map.Route = function(){
  //         /**
  //      * The total distance of the route.
  //      */
  //     this.distance = 0;
  
  //     this.speed = 0;
  
  //     this.pace = 0;
  
  //     this.seconds = 0;
  
  //     /**
  //      * The Garmin.Map.Markers that define the route.
  //      */
  //     this.markers = new Array();
  
  //     /**
  //      * The Garmin.Map.Lines that define the route.
  //      */
  //     this.lines = new Array();
  
  //     this.listeners = new Array();
  
  //     /*
  //      * True if distance is in metric.
  //      */
  //     this.metric = false;
  
  // };
  
  // Garmin.Map.Route.prototype = {
  
  //     addListener: function(name, action) {
  //       this.listeners.push(new Garmin.Map.Listener(name, action));
  //     },
  
  //     removeListeners: function(name) {
  //       var newListeners = new Array();
  //       for(var i = 0; i < this.listeners.length; i++) {
  //         var listener = this.listeners[i];
  //         if (listener.name != name) {
  //             newListeners.push(listener);
  //         }
  //       }
  //       this.listeners = newListeners;
  //     },
  
  //     fireListener: function(name, event){
  //         for(var i = 0; i < this.listeners.length; i++) {
  //             var listener = this.listeners[i];
  //             if (listener.name == name) {
  //                 listener.fire(event);
  //             }
  //         }
  //     },
  
  //     /**
  //      * Creates a new Marker and adds it to the Route.
  //      * @param shapeId - The shapeID to add.
  //      * @param point - The point of the Shape
  //      */
  //     addPoint: function(shapeId, point){
  //         if (typeof(shapeId) == 'undefined' || shapeId === null) {
  //             throw "Shape ID required to add point";
  //         }
  //         if (typeof(point) == 'undefined' || point === null) {
  //             throw "Point required to add point";
  //         }
  //         var marker = new Garmin.Map.Marker(shapeId, point);
  //         this.appendMarker(marker);
  //         return marker;
  //     },
  
  //     /**
  //      * The purpose of this method is to append a marker to the end of the route.
  //      * The marker must have a markerId. This method links the marker to the previous marker.
  //      *
  //      * @param marker - The marker to add to the end of the route.
  //      */
  //     appendMarker: function(marker) {
  //         if (typeof(marker) == 'undefined' || marker === null) {
  //             throw "Marker is required.";
  //         }
  //         if (typeof(marker.markerId) == 'undefined' || marker.getMarkerId() === null) {
  //             throw "Marker ID required to add a marker.";
  //         }
  //         var existingMarker = this.getMarker(marker.getMarkerId());
  //         if(existingMarker != null) {
  //             throw new Error("A marker with id " + marker.getMarkerId() + " already exists in the route.")
  //         }
  //         var last =  this.getEnd();
  //         if (last != null) {
  //             last.setNextMarkerId(marker.getMarkerId());
  //             marker.setPreviousMarkerId(last.getMarkerId());
  //         }
  //         this.markers.push(marker);
  //     },
  
  //     /**
  //      * The purpose of this method is to prepend a marker to the start of the route.
  //      * The marker must have a markerId. This method links the marker to the previous marker.
  //      *
  //      * @param marker - The marker to add to the end of the route.
  //      */
  //     prependMarker: function(marker) {
  //         if (typeof(marker) == 'undefined' || marker === null) {
  //             throw "Marker is required.";
  //         }
  //         if (typeof(marker.markerId) == 'undefined' || marker.getMarkerId() === null) {
  //             throw "Marker ID required to add a marker.";
  //         }
  //         var existingMarker = this.getMarker(marker.getMarkerId());
  //         if(existingMarker != null) {
  //             throw new Error("A marker with id " + marker.getMarkerId() + " already exists in the route.")
  //         }
  //         var first =  this.getStart();
  //         if (first != null) {
  //             first.setPreviousMarkerId(marker.getMarkerId());
  //             marker.setNextMarkerId(first.getMarkerId());
  //         }
  //         this.markers.push(marker);
  //     },
  
  //     /**
  //      * Inserts a marker between two adjacent markers.
  //      *
  //      * @param marker - The marker to be inserted between two adjacent markers.
  //      */
  //     insertMarker: function(marker) {
  //         if (typeof(marker) == 'undefined' || marker === null) {
  //             throw "Marker is required.";
  //         }
  //         if (typeof(marker.getMarkerId()) == 'undefined' || marker.getMarkerId() === null) {
  //             throw "Marker must have an ID.";
  //         }
  //         var existingMarker = this.getMarker(marker.getMarkerId());
  //         if(existingMarker != null) {
  //             throw new Error("A marker with id " + marker.getMarkerId() + " already exists in the route.")
  //         }
  //         if (marker.getPreviousMarkerId() == null) {
  //             var start = this.getStart();
  //             if (start != null) {
  //                 start.setPreviousMarkerId(marker.getMarkerId());
  //                 marker.setNextMarkerId(start.getMarkerId())
  //             }
  //         } else {
  //             var previous = this.getMarker(marker.getPreviousMarkerId());
  //             if (previous == null) {
  //                 throw marker.getPreviousMarkerId() + " does not exist"
  //             } else {
  //                 previous.setNextMarkerId(marker.getMarkerId())
  //             }
  //         }
  
  //         if (marker.getNextMarkerId() == null) {
  //             var end = this.getEnd();
  //             end.setNextMarkerId(marker.getMarkerId());
  //             marker.setPreviousMarkerId(end.getMarkerId());
  //         } else {
  //             var next = this.getMarker(marker.getNextMarkerId());
  //             next.setPreviousMarkerId(marker.getMarkerId())
  //         }
  //         this.markers.push(marker);
  //     },
  
  //     /**
  //      * Returns the line identified by its end points. The order of the
  //      * parameters does not matter.
  //      *
  //      * @param markerId1 - The starting marker Id of the desired line.
  //      * @param markerId2  - The ending marker Id of the desired line.
  //      * @return - The line whose start and end marker IDs match the specified values.
  //      */
  //     getLineForEndMarkers: function(markerId1, markerId2) {
  //         var line = null;
  //         for (var i = 0; i < this.lines.length; i++) {
  //             if (this.lines[i].hasMarkerId(markerId1) && this.lines[i].hasMarkerId(markerId2)) {
  //                 line = this.lines[i];
  //                 break;
  //             }
  //         }
  //         return line;
  //     },
  
  //     /**
  //      * Gets a marker from the Route.
  //      * @param markerId - The ID of the marker.
  //      * @return Marker matching the marker Id.
  //      */
  //     getMarker: function(markerId) {
  //         var marker = null;
  //         if (typeof(markerId) != 'undefined' && markerId != null) {
  //             for (var i = 0; i < this.markers.length; i++) {
  //               var nextMarker = this.markers[i];
  //               if (markerId === nextMarker.getMarkerId()) {
  //                   marker = nextMarker;
  //                   break;
  //               }
  //             }
  //         }
  //         return marker;
  //     },
  
  //     removeFirstMarker: function() {
  //        var firstMarker = this.getStart();
  //        if (firstMarker != null) {
  //            var markerId = firstMarker.getMarkerId();
  //            var nextMarkerId = firstMarker.getNextMarkerId();
  //            this.deleteMarker(markerId);
  //            if (nextMarkerId !=  null) {
  //                // Not technically a swap, but insures any queue commands references the old first marker now reference the new first marker.
  //                this.fireListener(Garmin.Map.Event.SWAP_MARKER_ID, {oldMarkerId: markerId, newMarkerId: nextMarkerId});
  //            }
  //        }
  //     },
  
  //     removeLastMarker: function() {
  //        var lastMarker = this.getEnd();
  //        if (lastMarker != null) {
  //            var markerId = lastMarker.getMarkerId();
  //            var prevMarkerId = lastMarker.getPreviousMarkerId();
  //            this.deleteMarker(markerId);
  //            if (prevMarkerId != null) {
  //                 // Not technically a swap, but insures any queue commands references the old last marker now reference the new last marker.
  //                 this.fireListener(Garmin.Map.Event.SWAP_MARKER_ID, {oldMarkerId: markerId, newMarkerId: prevMarkerId});
  //            }
  //        }
  //     },
  
  //     /**
  //      * This method changes the marker ID leaving the linkage and point the same.
  //      * It is primarily to replace the second marker with a "start" marker,
  //      * same deal if the last marker is deleted.
  //      * @param oldMarkerId - The markerId to be changed..
  //      * @param newMarkerId - The markerId replacing the old marker id.
  //      * otherwise, it is assumed to be the first marker.
  //      */
  //     swapMarker: function(oldMarkerId, newMarkerId) {
  //         if (oldMarkerId === null || typeof(oldMarkerId) == 'undefined') {
  //             throw "Old marker Id is required."
  //         }
  //         if (newMarkerId === null || typeof(newMarkerId) == 'undefined') {
  //             throw "New marker Id is required."
  //         }
  //         for(var i = 0; i < this.markers.length; i++) {
  //             this.markers[i].swapMarkerIds(oldMarkerId, newMarkerId);
  //         }
  //         for(var x = 0; x < this.lines.length; x++) {
  //             this.lines[x].swapMarkerIds(oldMarkerId, newMarkerId);
  //         }
  //         this.fireListener(Garmin.Map.Event.SWAP_MARKER_ID, {oldMarkerId: oldMarkerId, newMarkerId: newMarkerId});
  //     },
  
  //     /**
  //      * The purpose of this method is to store elevation for a line, and then fire an
  //      * Elevation Changed event if all route line elevations are present.
  //      *
  //      * @param lineId - The ID of the line to be updated.
  //      * @param samples - The sample elevations to store.
  //      */
  //     setLineElevation: function(lineId, samples) {
  //         // Make sure line still exists
  //         var line = this.getLine(lineId);
  //         if (line != null) {
  //             line.setElevations(samples);
  //         }
  //         if(this.isElevationComplete()) {
  //             this.fireListener(Garmin.Map.Event.ELEVATION_CHANGE, {});
  //         }
  //     },
  
  //     setLineElevationError: function(lineId, error) {
  //         // Make sure line still exists
  //         var line = this.getLine(lineId);
  //         if (line != null) {
  //             line.setElevations(null);
  //         }
  //         if(this.isElevationComplete()) {
  //             this.fireListener(Garmin.Map.Event.ELEVATION_CHANGE, {});
  //         }
  //     },
  
  //     /**
  //      * The purpose of this method is to test whether elevation has been received for all lines. If not, then we
  //      * are still waiting for a response for one or more lines.
  //      *
  //      */
  //     isElevationComplete: function() {
  //         var line;
  //         var lines = this.getLines();
  //         for(var i = 0; i < lines.length; i++) {
  //             line = lines[i];
  //             // Ignore null, set by elevation fetch errors.
  //             if(line.getElevations() != null && line.getElevations().length == 0) {
  //                 return false;
  //             }
  //         }
  //         return true;
  //     },
  
  //     /**
  //      * Deletes a marker from the route and
  //      * adjusts the marker linkage accordingly.
  //      * @param shapeId - The ID of the marker being deleted.
  //      */
  //     deleteMarker: function(shapeId) {
  //         var keptMarkers = new Array();
  //         for (var i = 0; i < this.markers.length; i++) {
  //             if (this.markers[i].getMarkerId() != shapeId) {
  //                 if (this.markers[i].getPreviousMarkerId() == shapeId) {
  //                     this.markers[i].setPreviousMarkerId(null);
  //                 }
  //                 if (this.markers[i].getNextMarkerId() == shapeId) {
  //                     this.markers[i].setNextMarkerId(null);
  //                 }
  //                 keptMarkers.push(this.markers[i]);
  //             }
  //         }
  //         this.markers = keptMarkers;
  //     },
  
  //     /**
  //      * The purpose of this method is to link together the markers
  //      * adjacent to a deleted marker.
  //      * @param markerId - The markerId being deleted.
  //      */
  //     linkAdjacentPointsForDeletedMarker: function(markerId) {
  //         if (typeof(markerId) == 'undefined' && markerId === null) {
  //             throw "linkAdjacentPointsForDeletedMarker: markerId is required."
  //         }
  //         var marker = this.getMarker(markerId);
  //         if (marker != null) {
  //             if(marker.getPreviousMarkerId() != null) {
  //                 var adjacentMarker = this.getMarker(marker.getPreviousMarkerId());
  //                 if (typeof(adjacentMarker) != 'undefined') {
  //                     adjacentMarker.setNextMarkerId(marker.getNextMarkerId());
  //                 }
  //             }
  //             if(marker.getNextMarkerId() != null) {
  //                 adjacentMarker = this.getMarker(marker.getNextMarkerId());
  //                 if (typeof(adjacentMarker) != 'undefined') {
  //                     adjacentMarker.setPreviousMarkerId(marker.getPreviousMarkerId());
  //                 }
  //             }
  //         }
  //      },
  
  //     addLine: function(line) {
  //         if (line.getLineId() == null || typeof(line.getLineId()) == 'undefined') {
  //             throw "Line Id is required to add line."
  //         }
  //         var existingLine =  this.getLine(line.getLineId());
  //         if (typeof(existingLine) != 'undefined' && existingLine != null) {
  //             throw "Line Id " + line.getLineId() + " already exists in Route."
  //         }
  //         if (line.getStartMarkerId() == null || typeof(line.getStartMarkerId()) == 'undefined') {
  //             throw "Start Element ID is required to add line."
  //         }
  //         if (line.getEndMarkerId() == null || typeof(line.getEndMarkerId()) == 'undefined') {
  //             throw "End Element ID is required to add line."
  //         }
  
  //         if (line.getDistance() == 0) {
  //             var start = null;
  //             var end = null;
  //             var lineDistance = 0;
  //             var limit = line.getPoints().length - 1;
  //             for(var i = 0; i < limit; i++) {
  //                 start = line.getPoints()[i];
  //                 end = line.getPoints()[i+1];
  //                 lineDistance += Garmin.Map.Utils.calculateDistanceBetweenPoints(start, end, this.isMetric());
  //             }
  //             line.setDistance(lineDistance);
  //         }
  //         var startMarker = this.getMarker(line.getStartMarkerId());
  //         if (startMarker == null) {
  //             throw "Start marker does not exist."
  //         }
  //         var endMarker = this.getMarker(line.getEndMarkerId());
  //         if (endMarker == null) {
  //             throw "End marker does not exist."
  //         }
  //         if(startMarker.getPreviousMarkerId() == null) {
  //             startMarker.setDistanceFromStart(0);
  //         } else if(startMarker.getNextMarkerId() == null) {
  //             startMarker.setDistanceFromStart(this.distance);
  //         }
  //         endMarker.setDistanceFromStart( startMarker.getDistanceFromStart() + line.getDistance());
  
  //         // If appended to the route, grow the distance, otherwise, it must be recalculated.
  //         if (endMarker.getNextMarkerId() == null) {
  //             this.distance += line.getDistance();
  //             this.seconds = Garmin.Map.Utils.calculateTime(this.distance, this.speed)*3600;
  //         } else {
  //             this.recalculateDistance();
  //         }
  
  //         this.lines.push(line);
  //     },
  
  //     /**
  //      * Recalculates the route distances from the existing lines.
  //      * It is only necessary to call this method if the following occurs:
  //      *
  //      * <ul>
  //      * <li>A marker is deleted.</li>
  //      * <li>A marker is moved.</li>
  //      * <li>A marker is added in the middle of a route.</li>
  //      * </ul>
  //      *
  //      * It is NOT necessary to call this method when markers are
  //      * appended to the end of the route with addPushPin().
  //      */
  //     recalculateDistance: function() {
  //         this.distance = 0;
  //         var startMarker = null;
  //         var endMarker = null;
  //         var lines = this.getLines();
  //         for (var i = 0; i < lines.length; i++) {
  //            var line = lines[i];
  //            startMarker = this.getMarker(line.getStartMarkerId());
  //            startMarker.setDistanceFromStart(this.distance);
  //            if (line.getDistance() == 0) {
  //                line.setDistance(Garmin.Map.Utils.calculateDistanceOfPoints(line.getPoints(), this.isMetric()));
  //            }
  //            this.distance += line.getDistance();
  //            endMarker = this.getMarker(line.getEndMarkerId());
  //            if (endMarker != null) {
  //              endMarker.setDistanceFromStart(this.distance);
  //            }
  //            this.seconds = Garmin.Map.Utils.calculateTime(this.distance, this.speed)*3600;
  //         }
  //     },
  
  //     /**
  //      * Returns an ordered list of lines.
  //      *
  //      * @return lines from start to finish.
  //      */
  //     getLines: function() {
  //         var results = new Array();
  //         var marker = this.getStart();
  //         while (marker != null) {
  //             var line = this.getLineByStartingMarkerId(marker.getMarkerId());
  //             if (line != null) {
  //                 results.push(line);
  //             }
  //             marker = this.getMarker(marker.getNextMarkerId());
  //         }
  //         return results;
  //     },
  
  //     getLine: function(lineMarkerId) {
  //         if (typeof(lineMarkerId) == 'undefined') {
  //             throw "lineMarkerId is required"
  //         }
  //         var line = null;
  //         for (var i = 0; i < this.lines.length; i++) {
  //             var nextLine = this.lines[i];
  //             if (nextLine.getLineId() === lineMarkerId) {
  //                 line = nextLine;
  //                 break;
  //             }
  //         }
  //         return line;
  //     },
  
  //     joinAdjacentLines: function(markerId) {
  //         var line = this.getLineByEndingMarkerId(markerId);
  //         var line2 = this.getLineByStartingMarkerId(markerId);
  //         for(var x = 0; x < line2.getPoints().length; x++) {
  //             line.getPoints().push(line2.getPoints()[x]);
  //         }
  //         for(var y = 0; y < line2.getElevations().length; y++) {
  //             line.getElevations().push(line2.getElevations()[y]);
  //         }
  //         line.setEndMarkerId(line2.getEndMarkerId());
  //         line.setDistance(line.getDistance() + line2.getDistance());
  //         this.deleteLine(line2.getLineId());
  //     },
  
  //     getLinesForMarkerId: function(markerId) {
  //         var matches = new Array();
  //         var precedingLine = null;
  //         var followingLine = null;
  //         var lines = this.getLines(); // gets ordered array of lines.
  //         for (var i = 0; i < lines.length; i++) {
  //             var line = lines[i];
  //             if (line.getEndMarkerId() === markerId) {
  //                 precedingLine = line;
  //             } else if (line.getStartMarkerId() === markerId) {
  //                 followingLine = line;
  //             }
  //         }
  //         // Enforce order of lines as proceeding and then following, if both are present.
  //         if (precedingLine != null) {
  //             matches.push(precedingLine);
  //         }
  //         if (followingLine != null) {
  //             matches.push(followingLine);
  //         }
  //         return matches;
  //     },
  
  //     getLineByStartingMarkerId: function(startingMarkerId) {
  //         var rval = null;
  //         for (var i = 0; i < this.lines.length; i++) {
  //             var line = this.lines[i];
  //             if (line.getStartMarkerId() === startingMarkerId) {
  //                rval = line;
  //                break;
  //             }
  //         }
  //         return rval;
  //     },
  
  //     getLineByEndingMarkerId: function(endingMarkerId) {
  //         var rval = null;
  //         for (var i = 0; i < this.lines.length; i++) {
  //             var line = this.lines[i];
  //             if (line.getEndMarkerId() === endingMarkerId) {
  //                 rval = line;
  //             }
  //         }
  //         return rval;
  //     },
  
  //     /**
  //      * Deletes the line specified by the Line Id.
  //      * No manipulation of start and end marker Ids is done by this method.
  //      * @param lineId - ID of the line to be deleted.
  //      */
  //     deleteLine: function(lineId) {
  //         var newLines = new Array();
  //         for (var i = 0; i < this.lines.length; i++) {
  //             if (this.lines[i].getLineId() != lineId) {
  //                 newLines.push(this.lines[i]);
  //             }
  //         }
  //         this.lines = newLines;
  //     },
  
  //     getDistance: function() {
  //         return this.distance;
  //     },
  
  //     setDistance: function(distance) {
  //         if (typeof(distance) == 'undefined' || distance === null) {
  //             throw "Distance is required.";
  //         } else if (!Garmin.Map.Validator.isNumeric(distance)) {
  //             throw "Distance must be numeric: " + distance;
  //         }
  //         this.distance = distance;
  //     },
  
  //     getSpeed: function() {
  //         return this.speed;
  //     },
  
  //     setSpeed: function(speed) {
  //         if (typeof(speed) == 'undefined' || speed === null) {
  //             throw "Speed is required.";
  //         } else if (!Garmin.Map.Validator.isNumeric(speed)) {
  //             throw "Speed must be numeric: " + speed;
  //         }
  //         this.speed = speed;
  //     },
  
  //     getPace: function() {
  //         return this.pace;
  //     },
  
  //     setPace: function(paceInSeconds) {
  //         this.pace = paceInSeconds;
  //     },
  
  //     getSeconds: function() {
  //         return this.seconds;
  //     },
  
  //     setSeconds: function(seconds) {
  //         if (typeof(seconds) == 'undefined' || seconds === null) {
  //             throw "Seconds is required.";
  //         } else if (!Garmin.Map.Validator.isNumeric(seconds)) {
  //             throw "Seconds must be numeric: " + seconds;
  //         }
  //         this.seconds = seconds;
  //     },
  
  //     setMetric: function(isMetric) {
  //         this.metric = isMetric;
  //     },
  
  //     isMetric: function() {
  //         return this.metric;
  //     },
  
  //     getStart: function() {
  //         var marker = null;
  //         if (this.markers.length > 1) {
  //             // Due to insertions, the start marker might not be the last marker.
  //             for (var i = 0; i < this.markers.length; i++) {
  //                 if (this.markers[i].getPreviousMarkerId() == null) {
  //                     if (marker != null) {
  //                         throw "Duplicate start markers found : " + marker.getMarkerId() + ", "  + this.markers[i].getMarkerId();
  //                     }
  //                     marker = this.markers[i];
  //                 }
  //             }
  //         } else if (this.markers.length == 1) {
  //             marker = this.markers[0];
  //         }
  //         return marker;
  //     },
  
  //     getEnd: function() {
  //         var marker = null;
  //         if (this.markers.length > 1) {
  //             // Due to insertions, the end marker might not be the last marker.
  //             for (var i = 0; i < this.markers.length; i++) {
  //                 if (this.markers[i].getNextMarkerId() == null) {
  //                     if (marker != null) {
  //                         throw "Duplicate end markers found : " + marker.getMarkerId() + ", "  + this.markers[i].getMarkerId();
  //                     }
  //                     marker = this.markers[i];
  //                 }
  //             }
  //         } else if (this.markers.length == 1) {
  //             marker = this.markers[0];
  //         }
  //         return marker;
  //     },
  
  //     getMarkerCount: function() {
  //         return this.markers.length;
  //     },
  
  //     /**
  //      * The purpose of this methods is to return all the points of the route.
  //      */
  //     getPoints: function() {
  //         var line = null;
  //         var points = new Array();
  //         var markers = this.getMarkers();
  
  //         // Get the point for the start marker
  //         var marker = this.getStart();
  //         if (marker != null) {
  //             points.push(marker.getPoint());
  //         }
  //         for (var i = 0; i < markers.length; i++) {
  //             marker = markers[i];
  //             line = this.getLineByStartingMarkerId(marker.getMarkerId());
  //             if (line != null) {
  //                 /*
  //                 The first point of each line is the last point of the previous line,
  //                 so skip the first point until processing the first line.
  //                  */
  //                 for (var x = 1; x < line.getPoints().length; x++) {
  //                     points.push(line.getPoints()[x]);
  //                 }
  //             }
  //         }
  //         return points;
  //     },
  
  //     /**
  //      * The purpose of this method is to return an ordered array of markers.
  //      * @return - Array of markers ordered from start to end.
  //      */
  //     getMarkers: function() {
  //         var markers = new Array();
  //         var marker = this.getStart();
  //         while (marker != null) {
  //             markers.push(marker);
  //             marker = this.getMarker(marker.getNextMarkerId());
  //         }
  //         if (this.markers.length != markers.length) {
  //             throw "Marker Link list error. Found " + markers.length + " but there should be " + this.markers.length;
  //         }
  //         return markers;
  //     },
  
  //     reset: function() {
  //         this.markers.clear();
  //         this.lines.clear();
  //         this.distance = 0;
  //         this.seconds = 0;
  //         this.fireListener(Garmin.Map.Event.RESET_ROUTE, {})
  //     },
  
  //     toJSON: function() {
  //         var json = new Array();
  //         json.push('{');
  //         json.push(',\"distance\":');
  //         json.push(this.distance);
  //         json.push(',\"metric\":');
  //         json.push(this.metric);
  //         json.push(',\"points\":');
  //         json.push(this.getPoints().toJSON());
  //         json.push('}');
  //         return json.join("");
  //     }
  
  // };
  
  // /**
  //  *
  //  * @description This class provides linked list functionality for markers on a map.
  //  *
  //  * @author Steve Mitchell
  //  * @email steve.mitchell@garmin.com
  //  *
  //  * Copyright(c) 2010, Garmin International
  //  */
  // Garmin.Map.Marker = function(shapeId, point){
  //     if (typeof(shapeId) == 'undefined' || shapeId === null) {
  //         throw "shapeId is required";
  //     }
  //     if (typeof(point) == 'undefined' || point === null) {
  //         throw "point is required";
  //     }
  //     /**
  //      * Only the shape ID is retained. All interaction is the shape
  //      * must be done with a fresh reference fetched from the map by Id.
  //      */
  // 	this.markerId = shapeId;
  
  //     this.point = point;
  // };
  
  // Garmin.Map.Marker.prototype = {
  
  //     /**
  //      * Only the shape ID is retained. All interaction is the shape
  //      * must be done with a fresh reference fetched from the map by Id.
  //      */
  //     previousMarkerId: null,
  
  //     /**
  //      * Only the shape ID is retained. All interaction is the shape
  //      * must be done with a fresh reference fetched from the map by Id.
  //      */
  //     nextMarkerId: null,
  
  //     distanceFromStart: 0,
  
  //     getMarkerId: function() {
  //         return this.markerId;
  //     },
  
  //     setMarkerId: function(shapeId) {
  //         this.markerId = shapeId;
  //     },
  
  //     getNextMarkerId: function() {
  //         return this.nextMarkerId;
  //     },
  
  //     setNextMarkerId: function(shapeId) {
  //         this.nextMarkerId = shapeId;
  //     },
  
  //     getPreviousMarkerId: function() {
  //         return this.previousMarkerId
  //     },
  
  //     setPreviousMarkerId: function(shapeId) {
  //         this.previousMarkerId = shapeId
  //     },
  
  //     getDistanceFromStart: function() {
  //         return this.distanceFromStart;
  //     },
  
  //     swapMarkerIds: function(oldMarkerId, newMarkerId) {
  //         if (this.getMarkerId() == oldMarkerId) {
  //             this.setMarkerId(newMarkerId);
  //         }
  //         if (this.getPreviousMarkerId() == oldMarkerId) {
  //             this.setPreviousMarkerId(newMarkerId);
  //         }
  //         if (this.getNextMarkerId() == oldMarkerId) {
  //             this.setNextMarkerId(newMarkerId);
  //         }
  //     },
  
  //     setDistanceFromStart: function(distance) {
  //         if (typeof(distance) == 'undefined' || distance === null) {
  //             throw "Distance is required.";
  //        } else if (!Garmin.Map.Validator.isNumeric(distance)) {
  //             throw "Distance must be numeric: " + distance;
  //         }
  //         this.distanceFromStart = distance;
  //     },
  
  //     getPoint: function() {
  //         return this.point;
  //     },
  
  //     setPoint: function(point) {
  //         if (typeof(point) == 'undefined' || point === null) {
  //             throw "A valid point is required.";
  //         }
  //         this.point = point;
  //     },
  
  //     toJSON: function() {
  //         var json = new Array();
  //         json.push('{');
  //         json.push('\"markerId\":');
  //         json.push('\"' + this.markerId + '\"');
  //         json.push(',\"point\":');
  //         json.push(this.point.toJSON());
  //         json.push(', previousMarkerId:');
  //         json.push('\"' + this.previousMarkerId + '\"');
  //         json.push(', nextMarkerId:');
  //         json.push('\"' + this.nextMarkerId + '\"');
  //         json.push(', \"distanceFromStart\":');
  //         json.push(this.distanceFromStart);
  //         json.push('}');
  //         return json.join("");
  //     }
  // };
  
  // /**
  //  *
  //  * @description This class provides linked list functionality for lines on a map.
  //  *
  //  * @author Steve Mitchell
  //  * @email steve.mitchell@garmin.com
  //  *
  //  * Copyright(c) 2010, Garmin International
  //  */
  // Garmin.Map.Line = function(lineMarkerId, startMarkerId, endMarkerId, points){
  //     if (typeof(lineMarkerId) == 'undefined' || lineMarkerId === null) {
  //         throw "lineMarkerId is required."
  //     }
  //     if (typeof(startMarkerId) == 'undefined' || startMarkerId === null) {
  //         throw "startMarkerId is required."
  //     }
  //     if (typeof(endMarkerId) == 'undefined' || endMarkerId === null) {
  //         throw "endMarkerId is required."
  //     }
  //     if (typeof(points) == 'undefined' || points === null) {
  //         throw "points are required."
  //     } else if (points.length < 2) {
  //         throw "A minimum of two points are required."
  //     }
  // 	this.lineId = lineMarkerId;
  //     this.startMarkerId = startMarkerId;
  //     this.endMarkerId = endMarkerId;
  //     this.points = points;
  //     this.elevations = new Array();
  //     this.rgb = Garmin.Map.Utils.LINE_COLOR;
  // };
  
  // Garmin.Map.Line.prototype = {
  
  //     /**
  //      * Starting shapeId.
  //      */
  //     startMarkerId: null,
  
  //     /**
  //      *
  //      * Ending shapeId.
  //      */
  //     endMarkerId: null,
  
  //     /**
  //      * The distance of this line.
  //      */
  //     distance: 0,
  
  //     /**
  //      * The directional bearing of this line.
  //      */
  //     bearing: 0,
  
  //     /**
  //      * Points of the line.
  //      */
  //     points: new Array(),
  
  //     getPoints: function() {
  //         return this.points;
  //     },
  
  //     getLineId: function() {
  //         return this.lineId;
  //     },
  
  //     setLineId: function(shapeId) {
  //         this.lineId = shapeId;
  //     },
  
  //     getStartMarkerId: function() {
  //         return this.startMarkerId;
  //     },
  
  //     setStartMarkerId: function(shapeId) {
  //         this.startMarkerId = shapeId;
  //     },
  
  //     getEndMarkerId: function() {
  //         return this.endMarkerId
  //     },
  
  //     setEndMarkerId: function(shapeId) {
  //         this.endMarkerId = shapeId
  //     },
  
  //     getDistance: function() {
  //         return this.distance;
  //     },
  
  //     setDistance: function(distance) {
  //         if (typeof(distance) == 'undefined' || distance === null) {
  //             throw "Distance is required.";
  //         } else if (!Garmin.Map.Validator.isNumeric(distance)) {
  //             throw "Distance must be numeric: " + distance;
  //         }
  //         this.distance = distance;
  //     },
  
  //     /**
  //      * Sets the line elevation samples for a path. These will
  //      * not necessarily correspond to the points of a line. Points are
  //      * used to draw a path. Elevations are evenly distributed samples
  //      * along that path.
  //      *
  //      * @param elevations - Array of Garmin.Map.Points;
  //      */
  //     setElevations: function(elevations) {
  //         this.elevations = elevations;
  //     },
  
  //     clearElevations: function() {
  //         this.elevations = new Array();
  //     },
  
  //     /**
  //      * Returns the line elevation samples for a path . These will
  //      * not necessarily correspond to the points of a line. Points are
  //      * used to draw a path. Elevations are evenly distributed samples
  //      * along that path.
  //      *
  //      * @return elevations - Array of Garmin.Map.Points;
  //      */
  //     getElevations: function() {
  //         if(typeof this.elevations == 'undefined' || this.elevations == null) {
  //             this.elevations = new Array();
  //         }
  //         return this.elevations;
  //     },
  
  //     getBearing: function(){
  //         return this.bearing;
  //     },
  
  //     setBearing: function(bearing) {
  //         if (typeof(bearing) == 'undefined' || bearing === null) {
  //             throw "Bearing is required.";
  //        } else if (!Garmin.Map.Validator.isNumeric(bearing)) {
  //             throw "Bearing must be numeric: " + bearing;
  //         }
  //         this.bearing = bearing;
  //     },
  
  //     getRgb: function() {
  //         return this.rgb;
  //     },
  
  //     setRgb: function(rgb) {
  //         this.rgb = rgb;
  //     },
  
  //     getPoints: function() {
  //         return this.points;
  //     },
  
  //     setPoints: function(points) {
  //         this.points = points;
  //     },
  
  //     swapMarkerIds: function(oldMarkerId, newMarkerId) {
  //         if (this.getStartMarkerId() == oldMarkerId) {
  //             this.setStartMarkerId(newMarkerId);
  //         }
  //         if (this.getEndMarkerId() == oldMarkerId) {
  //             this.setEndMarkerId(newMarkerId);
  //         }
  //     },
  
  
  //     /**
  //      * The purpose of this method is to test whether either
  //      * marker ID of the line match a given marker ID.
  //      *
  //      * @param markerId - The marker ID to be checked.
  //      */
  //     hasMarkerId: function(markerId) {
  //         return this.startMarkerId === markerId || this.endMarkerId === markerId;
  //     },
  
  //     toJSON: function() {
  //         var json = new Array();
  //         json.push('{');
  //         json.push('\"startMarkerId\":');
  //         json.push('\"' + this.startMarkerId + '\"');
  //         json.push(', \"endMarkerId\":');
  //         json.push('\"' + this.endMarkerId + '\"');
  //         json.push(', \"distance\":');
  //         json.push(this.distance);
  //         json.push(', \"bearing\":');
  //         json.push(this.bearing);
  //         json.push(', \"points\":');
  //         json.push(this.points.toJSON());
  //         json.push('}');
  //         return json.join("");
  //     },
  
  //     clone: function() {
  //         var line = new Garmin.Map.Line(
  //             this.lineId,
  //             this.startMarkerId,
  //             this.endMarkerId,
  //             this.points.clone()
  //         );
  //         line.setDistance(this.distance);
  //         line.setBearing(this.bearing);
  //         if(this.elevations != null && this.elevations.length > 0) {
  //             line.setElevations(this.elevations.clone());
  //         }
  //         return line;
  //     }
  // };
  
  /**
   *
   * @description This is the model class for a lat/lon point.
   *
   * @author Steve Mitchell
   * @email steve.mitchell@garmin.com
   *
   * Copyright(c) 2010, Garmin International
   * @param latitude - The latitude of the point.
   * @param longitude - The longitude of the point.
   * @param elevation - (optional) the elevation of the point.
   * @param alt - (Optional) alternate data
   */
  Garmin.Map.Point = function(latitude, longitude, elevation, alt){
      this.lat = parseFloat(latitude);
      if (!Garmin.Map.Validator.isValidLatitude(latitude)) {
          throw "Latitude is not valid: " + latitude;
      }
      this.lon = parseFloat(longitude);
      if (!Garmin.Map.Validator.isValidLongitude(longitude)) {
          throw "Longitude is not valid: " + longitude;
      }
      if (typeof(elevation) != 'undefined') {
          if (!Garmin.Map.Validator.isNumeric(elevation)) {
              throw "Elevation must be numeric: " + elevation;
          }
          this.elevation = parseFloat(elevation);
      }
      if (typeof(alt) !== 'undefined') {
          this.alt = alt;
      }
  }
  
  Garmin.Map.Point.prototype = {
  
      getLat: function() {
          return this.lat;
      },
  
      setLat: function(lat) {
          if (!Garmin.Map.Validator.isValidLatitude(lat)) {
              throw "Latitude is not valid: " + lat;
          }
          this.lat = lat;
      },
  
      getLon: function() {
          return this.lon;
      },
  
      setLon: function(lon) {
          if (!Garmin.Map.Validator.isValidLongitude(lon)) {
              throw "Longitude is not valid: " + lon;
          }
          this.lon = lon;
      },
  
  
      getElevation: function() {
          return this.elevation;
      },
  
      setElevation: function(elevation) {
          if (!Garmin.Map.Validator.isNumeric(elevation)) {
              throw "Elevation must be numeric: " + elevation;
          }
          this.elevation = elevation;
      },
  
      getAlt: function() {
          return this.alt;
      },
  
      setAlt: function(alt) {
          this.alt = alt;
      },
  
      toJSON: function() {
          if (typeof this.elevation == 'undefined') {
              this.elevation = 0;
          }
          return '{\"lat\":' + this.lat + ', \"lon\":' + this.lon + ', \"elevation\":' + this.elevation + ', \"alt\":' + this.alt + '}';
      },
  
      toString: function() {
          var value = this.lat + ',' + this.lon;
          if (typeof this.elevation !== 'undefined') {
              value += ',' + this.elevation;
          }
          if (typeof this.alt !== 'undefined') {
              value += ',' + this.alt;
          }
          return value
      }
  
  };
  
  /**
   * Routes Validator is a collection of route validation functions.
   */
  Garmin.Map.Validator = {};
  
  /**
   * Tests whether a value is a valid number.
   * @param value - The value to be tested.
   * @return true if the value is a number.
   */
  Garmin.Map.Validator.isNumeric = function(value) {
      if (isNaN(parseFloat(value))) {
          return false;
      }
      return true
  }
  
  /**
   * Tests whether a latitude valid
   * @param value - The latitude to be tested.
   * @return true if the value is a latitude is between -85 and 85.
   */
  Garmin.Map.Validator.isValidLatitude = function(value) {
          var rval = false;
          if (Garmin.Map.Validator.isNumeric(value) && Math.abs(value) < 91) {
            rval = true;
          }
          return rval;
  }
  
  /**
   * Tests whether a longitude valid
   * @param value - The longitude to be tested.
   * @return true if the value is a longitude is between -180 and 180.
   */
  Garmin.Map.Validator.isValidLongitude = function(value) {
          var rval = false;
          if (Garmin.Map.Validator.isNumeric(value) && Math.abs(value) < 181) {
            rval = true;
          }
          return rval;
  }
  
  // /**
  //  *
  //  * @description This class contains parameters needed for handling direction callbacks.
  //  *
  //  * @author Steve Mitchell
  //  * @email steve.mitchell@garmin.com
  //  *
  //  * Copyright(c) 2010, Garmin International
  //  * @param marker1 = The marker for the start of the directions.
  //  * @param marker2 = The marker for the end of the directions.
  //  */
  // Garmin.Map.DirectionCallbackParam = function(marker1, marker2){
  //     if(typeof(marker1) == 'undefined' || marker1 === null) {
  //         throw "marker1 is required"
  //     }
  //     if(typeof(marker2) == 'undefined' || marker2 === null) {
  //         throw "marker2 is required"
  //     }
  //     this.marker1 = marker1;
  //     this.marker2 = marker2;
  // };